module.exports = {
  "$id": "ffpBinding",
  "type": "object",
  "title": "金鹏卡绑定",
  "properties": {
    "cid": {
      "title": "金鹏卡号",
      "type": "string",
      "customValidate": "ffbId"
    },
    "loginPwd": {
      "title": "密码",
      "type": "string"
      // "format": "newPassword"
    }
  },
  "required": [
    "cid",
    "loginPwd"
  ],
  "errorMessage": {
    "cid": {
      "required": "请输入金鹏卡号/手机/身份证号"
    },
    "loginPwd": {
      "message": "请输入密码，密码要求8-15位，大小写字母、数字、特殊符号4种中的至少3种",
      "required": "请输入密码"
    }
  }
}
